import { useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Logo } from "@/components/Logo";
import { toast } from "sonner";
import { track } from "@/lib/analytics";

export default function Signup() {
    const { register } = useAuth();
    const navigate = useNavigate();
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const startedRef = useRef(false);

    const markStarted = (method) => {
        if (startedRef.current) return;
        startedRef.current = true;
        track("registration_started", { method });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        markStarted("email");
        setLoading(true);
        const res = await register(email, password, name);
        setLoading(false);
        if (res.ok) {
            track("registration_completed", { method: "email" });
            toast.success("Welcome to Otherkind");
            navigate("/");
        } else {
            toast.error(res.error || "Signup failed");
        }
    };

    const handleGoogle = () => {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        markStarted("google");
        const redirectUrl = window.location.origin + "/";
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    };

    return (
        <div className="ok-container py-16 max-w-md mx-auto" data-testid="signup-page">
            <div className="text-center mb-8"><div className="inline-block"><Logo /></div></div>
            <div className="ok-card p-8">
                <h1 className="font-display text-2xl mb-1">Create account</h1>
                <p className="text-sm opacity-60 mb-6">Lodge encounters, rate cases, and join the community.</p>
                <form onSubmit={handleSubmit} className="space-y-4" data-testid="signup-form">
                    <div>
                        <label className="font-mono text-[10px] uppercase tracking-widest opacity-60 block mb-1.5">Display name</label>
                        <input type="text" required value={name} onChange={(e) => { markStarted("email"); setName(e.target.value); }} className="ok-input" data-testid="signup-name" />
                    </div>
                    <div>
                        <label className="font-mono text-[10px] uppercase tracking-widest opacity-60 block mb-1.5">Email</label>
                        <input type="email" required value={email} onChange={(e) => { markStarted("email"); setEmail(e.target.value); }} className="ok-input" data-testid="signup-email" />
                    </div>
                    <div>
                        <label className="font-mono text-[10px] uppercase tracking-widest opacity-60 block mb-1.5">Password (min 6 chars)</label>
                        <input type="password" required minLength={6} value={password} onChange={(e) => { markStarted("email"); setPassword(e.target.value); }} className="ok-input" data-testid="signup-password" />
                    </div>
                    <button type="submit" disabled={loading} className="ok-btn-primary w-full justify-center" data-testid="signup-submit">
                        {loading ? "Creating…" : "Create account"}
                    </button>
                </form>
                <div className="my-5 flex items-center gap-3">
                    <div className="flex-1 ok-divider" /><span className="font-mono text-[10px] uppercase tracking-widest opacity-50">OR</span><div className="flex-1 ok-divider" />
                </div>
                <button onClick={handleGoogle} className="ok-btn-outline w-full justify-center" data-testid="signup-google">
                    Continue with Google
                </button>
                <p className="text-sm text-center mt-6 opacity-70">
                    Have an account? <Link to="/login" className="ok-link" data-testid="signup-to-login">Sign in</Link>
                </p>
            </div>
        </div>
    );
}
